/** Routes for a customer's property (tracker item 54). */

/** Read-only property detail page */
export function propertyDetailPath(property: { id: string; customerId: string }): string {
  return `/customers/${encodeURIComponent(property.customerId)}/properties/${encodeURIComponent(property.id)}`;
}

/** Property edit form */
export function propertyEditPath(property: { id: string; customerId: string }): string {
  return `${propertyDetailPath(property)}/edit`;
}
